/* esm.sh - applesauce-core@5.2.0/helpers/tags */
export * from "/*applesauce-core@5.2.0/esnext/helpers/tags.mjs";
